  var swiper = new Swiper(".trust-review-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 1200px
    1350: {
      slidesPerView: 4,
      spaceBetween: 20
    },
    // when window width is >= 990px
    1025: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    // when window width is >= 750px
    750: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    // when window width is < 750px
    0: {
      slidesPerView: 1.4,
      spaceBetween: 10
    }
  }
});
